<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">Nueva Subcategoria de producto</h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewItem)">

        <div class="row">
          <el-select
          size="large"
          :placeholder="$t('app.modules.category_product.headers.category')"
          v-model="subcategory.idCategoriaProducto"
          >
            <el-option
              v-for="rol in categorias"
              class="select-primary"
              :value="rol.idCategoriaProducto"
              :label="rol.nombreCategoria"
              :key="rol.idCategoriaProducto"
            >
            </el-option>
          </el-select>
        </div>

        <div v-for="(lang) in subcategory.traducciones">
          <h6>{{ lang.idioma.idioma }}</h6>
          <div class="row">
            <div class="col-12">
              <fg-input
                type="text"
                name="minLength"
                :label="$t('app.modules.category_product.headers.name')"
                v-model="lang.nombreSubcategoria"
              >
              </fg-input>
            </div>
          </div>
          <div class="separate"></div>
        </div>

        <div class="row">
          <div class="col-sm-6 form-group has-label">
            <div class="row">
              <label style="margin-left: 15px">{{ $t("app.modules.messages.headers.state") }}</label>
            </div>
            <template>
              <n-switch v-model="subcategory.activo">
                <i class="now-ui-icons ui-1_check" slot="on"></i>
                <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
              </n-switch>
            </template>
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left btn-secondary" @click.native="cancelAdd"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import SubcategoriaProducto from "@/models/familiaProducto/SubcategoriaProducto";
import SubcategoriaProductoTraduccion from "@/models/familiaProducto/SubcategoriaProductoTraduccion";
import Idioma from "@/models/familiaProducto/Idioma";
import {getResponse} from "@/util/utilities";

export default {
  components: {},
  data() {
    return {
      categorias: [],
      selectIncompleto: false,
      subcategory: new SubcategoriaProducto(),
      minLength: "",
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      },
      modals: {
        classic: false,
        notice: false,
        mini: false
      }
    };
  },
  computed: {
    ...mapState(["user", "availableLangs"])
  },
  created() {
    this.subcategory.claveIdioma = this.$store.state.lang;
    this.subcategory.usuarios_idUsuario = this.user.idUsuario;
    this.subcategory.traducciones = this.availableLangs.map((lang) => new SubcategoriaProductoTraduccion({
      idSubcategoriaProductoTraduccion: 0,
      nombreSubcategoria: "",
      idiomas_idIdioma: lang.idIdioma,
      idioma: new Idioma({
        idIdioma: lang.idIdioma,
        idioma: lang.idioma,
        clave: lang.clave
      })
    }));
    this.getCategorias();
  },
  mounted() {
    EventBus.$on("subcategoriaproducto-add", async () => {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    cancelAdd() {
      for (let lang of this.subcategory.traducciones) {
        lang.nombreSubcategoria = "";
      }
      this.subcategory.idCategoriaProducto = this.categorias[0].idCategoriaProducto;
      this.subcategory.nombreSubategoria = "";
      this.subcategory.activo = true;
      this.modals.classic = false;
    },
    async submitNewItem() {
      if (this.subcategory.idCategoriaProducto > 0) {
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });

        try
        {
          this.subcategory.traducciones.forEach(t => {
            if(!t.nombreSubcategoria) throw new Error(this.$t('app.modules.category_product.errors.no_name') + ": " + t.idioma.idioma);
          });

          let response = await this.addNewRow();

          if(response){
            this.notifyMessage("success", this.$t("app.promps.save_success"));
            EventBus.$emit("reload-items");
            this.cancelAdd();
          }
          else this.notifyMessage("danger", this.$t("app.promps.error"));
        }
        catch (e){
          this.notifyMessage('danger', e.message);
        }
        finally
        {
          this.$swal.close();
        }

        this.$swal.close();
      } else {
        this.selectIncompleto = true;
      }
    },
    async addNewRow (){
      let request = await this.$http.post(route("Subcategoria/AddSubcategoria"), this.subcategory);
      return getResponse(request, null);
    },
    async getCategorias(){
      let payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0,
        onlyActives: true
      };

      let request = await this.$http.post(route("CategoriaProducto/getCategoria"), payload);
      let response = getResponse(request, null);

      if(response != null){
        this.categorias = response.categoriaProducto

        if(this.categorias.length > 0){
          this.subcategory.idCategoriaProducto = this.categorias[0].idCategoriaProducto;
        }

      }
      else this.notifyMessage("danger", this.$t("app.promps.error"));
    }
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
<style scoped>
.el-select--large {
  width: 100% !important;
}
</style>
